import React from 'react';
import ReactDOM from 'react-dom/client';
// 2026-05-04 typography standardization — Inter (UI sans) + JetBrains
// Mono (technical data). Bundled via @fontsource/* so the app has zero
// external CDN dependencies for fonts (no Google Fonts call).
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/600.css';
import './index.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Performance metrics
reportWebVitals();
// Stage 10 — Professional DMS: SoD, Approval Inbox, AI Auditor, Reference Evidence, Policy Health
